
import React from 'react';
import { Search, Star, Hammer, Blocks } from 'lucide-react';
import SolutionCard from './cards/SolutionCard';

const DeepResearchAgents = () => {
  return (
    <SolutionCard
      icon={Search}
      title="Deep Research Agents"
      subtitle="OpenPipe for Research Agents"
      description="Power the most advanced research agents with innovative fine-tuning techniques on OpenPipe."
    >
      <div className="grid gap-4 md:grid-cols-3 mt-2">
        <div className="space-y-2 p-3 rounded-lg bg-secondary/30 hover:bg-secondary/50 transition-colors">
          <Star className="h-5 w-5 text-primary mb-2" />
          <h3 className="solution-heading">State of the art</h3>
          <p className="text-muted-foreground mt-0">
            Increase agent success rates beyond what prompted models alone can achieve.
          </p>
        </div>
        <div className="space-y-2 p-3 rounded-lg bg-secondary/30 hover:bg-secondary/50 transition-colors">
          <Hammer className="h-5 w-5 text-primary mb-2" />
          <h3 className="solution-heading">Advanced tool calls</h3>
          <p className="text-muted-foreground mt-0">
            Teach your agent how to use the tools at its disposal to solve complicated real-world tasks.
          </p>
        </div>
        <div className="space-y-2 p-3 rounded-lg bg-secondary/30 hover:bg-secondary/50 transition-colors">
          <Blocks className="h-5 w-5 text-primary mb-2" />
          <h3 className="solution-heading">Domain expertise</h3>
          <p className="text-muted-foreground mt-0">
            Adapt your research agents to niche domains or usage patterns and watch them excel.
          </p>
        </div>
      </div>
    </SolutionCard>
  );
};

export default DeepResearchAgents;
